import React from "react";
import { Image, Layout, Type, Film } from "lucide-react";
import type { FormData } from "../types";

interface SlideOptionsSectionProps {
  formData: FormData;
  onFormChange: (field: keyof FormData, value: any) => void;
}

const SlideOptionsSection: React.FC<SlideOptionsSectionProps> = ({
  formData,
  onFormChange,
}) => {
  return (
    <>
      <div>
        <label className="block text-sm font-medium mb-2 text-(--text-secondary)">
          Número de Slides *
        </label>
        <select
          value={formData.slideCount}
          onChange={(e) => onFormChange("slideCount", e.target.value)}
          className="w-full p-3 border border-(--border-color) rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition bg-(--input-bg) text-(--text-primary)"
        >
          <option value="10">10 slides</option>
          <option value="15">15 slides</option>
          <option value="20">20 slides</option>
          <option value="25">25 slides</option>
          <option value="30">30 slides</option>
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium mb-2 text-(--text-secondary)">
          Elementos Incluídos
        </label>
        <div className="grid grid-cols-2 gap-2">
          {[
            {
              key: "includeImages" as const,
              icon: Image,
              label: "Imagens",
            },
            {
              key: "includeDiagrams" as const,
              icon: Layout,
              label: "Diagramas",
            },
            {
              key: "includeExamples" as const,
              icon: Type,
              label: "Exemplos",
            },
            {
              key: "includeSummary" as const,
              icon: Film,
              label: "Resumo",
            },
          ].map(({ key, icon: Icon, label }) => (
            <label
              key={key}
              className="flex items-center gap-2 p-2 border border-(--border-color) rounded-lg cursor-pointer hover:bg-(--bg-accent) transition"
            >
              <input
                type="checkbox"
                checked={formData[key]}
                onChange={(e) => onFormChange(key, e.target.checked)}
                className="w-4 h-4 rounded accent-blue-500"
              />
              <div className="flex items-center gap-1">
                <Icon className="w-4 h-4 text-(--text-secondary)" />
                <span className="text-sm text-(--text-primary)">{label}</span>
              </div>
            </label>
          ))}
        </div>
      </div>
    </>
  );
};

export default SlideOptionsSection;
